import script from "./SideArticle.vue?vue&type=script&setup=true&lang=js"
export * from "./SideArticle.vue?vue&type=script&setup=true&lang=js"

import "./SideArticle.vue?vue&type=style&index=0&id=33bdc13e&lang=stylus"

const __exports__ = script;

export default __exports__